<template>

    <v-dialog
      v-model="$store.state.dialogobuscaCliente"
      max-width="490"
      >
                <div>
      <v-system-bar window dark>
        <v-icon @click="$store.commit('dialogobuscaCliente')">mdi-close</v-icon>
      </v-system-bar>
      
    </div>
      <v-card>

              <v-text-field
              class="pa-3 mt-2"
              append-icon="mdi-magnify"
               @keyup.enter="verificaNodoHijo"
                @click:append="verificaNodoHijo"
                @keyup.esc="$store.commit('dialogobuscaCliente')"
                v-model="dni"
                :counter="8"
                :rules="dniRules"
                label="Ingresa tu DNI"
                required
              ></v-text-field>

      </v-card>

        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          color="error"
          top
        >
          NO EXISTE
          <v-btn
            color="blue"
            text
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>

    </v-dialog>
</template>

<script>
import { db } from '../db'
import mensajeCard from '@/components/mensajeCard'
import store from '@/store/index'

  export default {
    name: 'dialogoCliente',

      firebase: {
        clientes: db.database().ref("cliente").orderByChild("orden"),
      },

    data() {
        return {
        snackbar:false,
        timeout: 2000,
        clientes:[],
        cliente:[],
        direc:[],
        dni: '',
        existe:'',
        dniRules: [
        v => !!v || 'Dni is required',
        v => (v && v.length == 8) || 'Tiene que ser de 8 dig',
      ],
        }
      },

    methods: {

          verificaNodoHijo(){
            var cate = []
            for(var i=0;i<this.clientes.length;i++){
                if(this.clientes[i].dni==this.dni.trim()){
                  cate = this.clientes[i]
                    this.cliente=[]
            this.cliente.push({
                    ruc:cate.ruc,
                    dni:cate.dni,
                    nombreCompleto:cate.nombreCompleto,
                    celular:cate.celular,
                    correo:cate.correo, 
                    nacimiento:cate.nacimiento
                }),
            this.direc = [],
                this.direc.push({
                    departamento:cate.departamento,
                    provincia:cate.provincia,
                    distrito:cate.distrito,
                    direccion:cate.direccion,
                    referencia:cate.referencia
                }),
                store.commit('ingresaDireccion',this.direc),
                store.commit('ingresacliente',this.cliente)
                store.commit('dialogobuscaCliente')
                }
                else{
                    this.snackbar=true
                }
            }
           
        },


         },


  }
</script>